import * as React from "react";

import Help from "@material-ui/icons/HelpTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import CardList from "~/components/CustomerSupport/CardList";
import Topic from "~/components/CustomerSupport/Topic";
import ContactFormContainer from "~/containers/ContactForm/ContactFormContainer";
import NotificationsContainer from "~/containers/Notifications/NotificationsContainer";
import { StyledCard as Card } from "~/layouts/StyledCard";
import SupportDashboardLayout from "~/layouts/SupportDashboardLayout";

interface IParams {
  reason?: string;
}

class ContactFormIndex extends React.Component<
  WithTranslation & RouteComponentProps<IParams>
> {
  public render() {
    const {
      t,
      match: {
        params: { reason = "" }
      },
      location: { search }
    } = this.props;

    const query = new URLSearchParams(search);
    const orderNumber = query.get("orderNumber") || "";
    const description = query.get("description") || "";
    const contactReason = query.get("reason") || reason || "";

    return (
      <SupportDashboardLayout>
        <CardList>
          <Card>
            <Topic
              icon={Help}
              title={t("header.title")}
              description={t("header.description")}
            />
          </Card>

          <NotificationsContainer />

          <ContactFormContainer
            reason={contactReason}
            orderNumber={orderNumber}
            description={description}
          />
        </CardList>
      </SupportDashboardLayout>
    );
  }
}

export default withTranslation("contactForm")(ContactFormIndex);



// WEBPACK FOOTER //
// ./src/pages/ContactForm/ContactFormIndex.tsx